<div class="event-records-container">
  <h1 class="page-title">事件紀錄簿</h1>

  <!-- 頁籤選單 -->
  <div class="tab-menu">
    <button class="tab-button" [class.active]="activeTab === 'add'" (click)="setActiveTab('add')">新增記錄</button>
    <button class="tab-button" [class.active]="activeTab === 'list'" (click)="setActiveTab('list')">記錄查詢</button>
    <button class="tab-button" [class.active]="activeTab === 'stats'" (click)="setActiveTab('stats')">統計分析</button>
  </div>

  <!-- 新增記錄頁籤 -->
  <div class="tab-content" *ngIf="activeTab === 'add'">
    <div class="section-header">
      <h2>記錄新的違規或缺失事件</h2>
      <p class="description">
        在此記錄公司發生的違規、罰款或稽核缺失事件，這些記錄將協助您識別需要特別關注的法規領域。
      </p>
    </div>

    <div class="event-form">
      <div class="form-grid">
        <div class="form-group">
          <label for="event-date">事件日期*</label>
          <input
            type="date"
            id="event-date"
            [(ngModel)]="eventData.date"
            required
          >
        </div>

        <div class="form-group">
          <label for="event-type">事件類型*</label>
          <select
            id="event-type"
            [(ngModel)]="eventData.type"
            required
          >
            <option value="" disabled selected>請選擇類型</option>
            <option *ngFor="let type of eventTypes" [value]="type.value">
              {{type.label}}
            </option>
          </select>
        </div>

        <div class="form-group full-width">
          <label for="event-title">事件標題*</label>
          <input
            type="text"
            id="event-title"
            [(ngModel)]="eventData.title"
            placeholder="簡短描述事件"
            required
          >
        </div>

        <div class="form-group full-width">
          <label for="event-description">詳細描述*</label>
          <textarea
            id="event-description"
            [(ngModel)]="eventData.description"
            rows="4"
            placeholder="詳細說明事件的經過和影響"
            required
          ></textarea>
        </div>

        <div class="form-group full-width">
          <label for="event-law">相關法規</label>
          <input
            type="text"
            id="event-law"
            [(ngModel)]="eventData.lawReference"
            placeholder="引用相關法規條文"
          >
        </div>

        <div class="form-group" *ngIf="eventData.type === 'fine'">
          <label for="event-penalty">罰款金額</label>
          <div class="input-with-suffix">
            <input
              type="number"
              id="event-penalty"
              [(ngModel)]="eventData.penalty"
              placeholder="例如: 50000"
            >
            <span class="input-suffix">元</span>
          </div>
        </div>

        <div class="form-group">
          <label for="event-status">處理狀態</label>
          <select
            id="event-status"
            [(ngModel)]="eventData.status"
          >
            <option *ngFor="let status of statusOptions" [value]="status.value">
              {{status.label}}
            </option>
          </select>
        </div>
      </div>

      <div class="file-upload-section">
        <label>上傳相關檔案：</label>
        <div class="file-upload-container">
          <input
            type="file"
            id="file-upload"
            (change)="onFileSelected($event)"
            class="hidden-input"
          >
          <label for="file-upload" class="file-upload-button">
            選擇檔案
          </label>
          <span class="selected-file" *ngIf="selectedFile">
            已選擇: {{selectedFile.name}}
          </span>
        </div>
        <span class="upload-hint">可上傳照片、處分書、報告等相關文件</span>
      </div>

      <div class="form-actions">
        <button type="button" class="btn primary-btn" (click)="saveEvent()">儲存記錄</button>
        <button type="button" class="btn secondary-btn" (click)="resetForm()">重置</button>
      </div>
    </div>
  </div>

  <!-- 記錄查詢頁籤 -->
  <div class="tab-content" *ngIf="activeTab === 'list'">
    <div class="section-header">
      <h2>違規與缺失記錄查詢</h2>
      <p class="description">
        查看並管理所有已記錄的違規、罰款和稽核缺失事件，篩選特定類型的記錄以找出規律性問題。
      </p>
    </div>

    <div class="filter-section">
      <div class="search-input-group">
        <input
          type="text"
          placeholder="關鍵字搜尋"
          [(ngModel)]="searchTerm"
          (input)="applyFilters()"
        >
        <button *ngIf="searchTerm" class="clear-button" (click)="searchTerm=''; applyFilters()">✕</button>
      </div>

      <div class="filter-select">
        <select [(ngModel)]="selectedType" (change)="applyFilters()">
          <option value="all">全部類型</option>
          <option *ngFor="let type of eventTypes" [value]="type.value">
            {{type.label}}
          </option>
        </select>
      </div>
    </div>

    <div class="records-table-container">
      <table class="records-table" *ngIf="filteredRecords.length > 0">
        <thead>
          <tr>
            <th>日期</th>
            <th>類型</th>
            <th>標題</th>
            <th>相關法規</th>
            <th>狀態</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let record of filteredRecords">
            <td>{{record.date | date:'yyyy-MM-dd'}}</td>
            <td>{{getTypeLabel(record.type)}}</td>
            <td>{{record.title}}</td>
            <td>{{record.lawReference}}</td>
            <td>
              <span class="status-badge" [class]="'status-' + record.status">
                {{getStatusLabel(record.status)}}
              </span>
            </td>
            <td class="actions-cell">
              <button class="icon-button" title="刪除" (click)="deleteRecord(record.id)">🗑️</button>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="no-records-message" *ngIf="filteredRecords.length === 0">
        沒有找到符合條件的記錄
      </div>
    </div>
  </div>

  <!-- 統計分析頁籤 -->
  <div class="tab-content" *ngIf="activeTab === 'stats'">
    <div class="section-header">
      <h2>違規與缺失統計分析</h2>
      <p class="description">
        分析您的違規和缺失記錄，找出重複發生的問題和需要重點關注的法規領域。
      </p>
    </div>

    <div class="stats-grid">
      <div class="stats-card">
        <h3>依類型統計</h3>
        <div class="stats-content">
          <ul class="stats-list">
            <li *ngFor="let typeStat of getStatistics().typeStats">
              <span class="stat-label">{{typeStat.label}}</span>
              <span class="stat-value">{{typeStat.count}} 件</span>
              <div class="stat-bar" [style.width.%]="(typeStat.count / eventRecords.length) * 100"></div>
            </li>
          </ul>
        </div>
      </div>

      <div class="stats-card">
        <h3>最常違反法規 (Top 5)</h3>
        <div class="stats-content">
          <ul class="stats-list" *ngIf="getStatistics().lawStats.length > 0">
            <li *ngFor="let lawStat of getStatistics().lawStats">
              <span class="stat-label">{{lawStat.law}}</span>
              <span class="stat-value">{{lawStat.count}} 件</span>
            </li>
          </ul>
          <div class="no-stats-message" *ngIf="getStatistics().lawStats.length === 0">
            尚無足夠資料進行分析
          </div>
        </div>
      </div>
    </div>

    <div class="insight-section" *ngIf="eventRecords.length > 0">
      <h3>法規遵循建議</h3>
      <div class="insight-card">
        <p>根據您的記錄，建議關注以下事項：</p>
        <ul>
          <li *ngIf="getStatistics().lawStats.length > 0">
            重點檢視 {{getStatistics().lawStats[0].law}} 相關法規要求
          </li>
          <li *ngIf="getStatistics().mostCommonType !== null">
            {{getStatistics().mostCommonType!.label}} 是最常見的問題類型，應優先改善
          </li>
          <li>定期檢視所有未解決的項目，避免因延遲處理導致更嚴重的後果</li>
        </ul>
      </div>
    </div>
  </div>
</div>
